import React from 'react';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const Work = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('work');

    // Get the work content data
    const workData = content.length > 0 ? content[0].content_data : null;

    if (isLoading) {
        return (
            <section className="section work-area bg-overlay overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <LoadingSpinner size="lg" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (isError) {
        return (
            <section className="section work-area bg-overlay overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <ErrorMessage error={error} onRetry={() => loadContentBySection('work')} />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!workData) {
        return (
            <section className="section work-area bg-overlay overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="text-center">
                                <p className="text-white">No work content available.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="section work-area bg-overlay overflow-hidden ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Work Content */}
                        <div className="work-content text-center">
                            <h2 className="text-white">{workData.heading}</h2>
                            <p className="text-white my-3 mt-sm-4 mb-sm-5">{workData.headingText}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {workData.workData && workData.workData.map((item, idx) => (
                        <div key={`w_${idx}`} className="col-12 col-md-4">
                            {/* Single Work */}
                            <div className="single-work text-center p-3">
                                {/* Work Icon */}
                                <div className="work-icon">
                                    <img className="avatar-md" src={item.image} alt="" />
                                </div>
                                <h3 className="text-white py-3">{item.title}</h3>
                                <p className="text-white">{item.content}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Work;